<template>
    <div class="question-comments-wrap">

        <div v-if="comments">
            <div class="question-comment d-flex" v-for="(comment, i) in comments" :key="i">
                <div class="question-comment-left position-relative mr-3 d-flex">
                    <input class="question-comment-vote-count" type="text" v-model="commentVoteCount" disabled>
                    <div class="question-comment-vote-flag d-flex flex-column w-full">
                        <el-button class="question-comment-vote" :class="isVoted ? 'active' : ''" @click="handleCommentVote()">
                            <el-icon><CaretTop /></el-icon>
                        </el-button>
                        <el-button class="question-comment-flag" :class="isMarked ? 'active' : ''" @click="this.isMarked=!this.isMarked">
                            <el-icon><Flag /></el-icon>
                        </el-button>
                    </div>
                </div>
                <div class="question-comment-content">
                    <p>{{comment.content}} <a href="#" class="question-comment-author">{{comment.author}}</a>
                    <span class="question-comment-date">{{comment.date}}</span></p>
                </div>
            </div>
        </div>

        <div class="question-comment-form mt-4">
            <a v-if="!isShowCommentForm" @click.prevent="isShowCommentForm=true" href="#" class="question-comment-add btn theme-btn">
                Add a comment
            </a>
            <div class="question-comment-box" v-if="isShowCommentForm">
                <el-input
                    v-model="commentContent"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    type="textarea"
                    placeholder="Use comments to ask more information or suggest improvements."
                />
                <el-button class="btn theme-btn mt-2">Add comment</el-button>
            </div>
        </div>

    </div>
</template>


<script>
import { CaretTop, Flag } from '@element-plus/icons-vue';

export default {
    name: 'QuestionComment',
    props: ['comments'],
    components: {
        CaretTop,
        Flag
    },
    data() {
        return {
            commentVoteCount: '',
            isShowCommentForm: false,
            isVoted: false,
            isMarked: false,
        }
    },
    methods: {

        handleCommentVote() {
            if (!this.isVoted ==true) {
                this.commentVoteCount++;
                this.isVoted = true;
            } else {
                this.commentVoteCount--;
                if (this.commentVoteCount == 0) {
                    this.commentVoteCount = '';
                }
                this.isVoted = false;
            }
        }
    }
}
</script>